export default "__VITE_ASSET___$_hsLZf__"